<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div>
    <p v-if="searchError">
      <a-alert
        message="Kesalahan Pencarian"
        :description="searchError"
        type="error"
        showIcon
        closable
      />
    </p>
    <a-form layout="horizontal" @submit="handleSubmit" :form="form">
      <a-form-item v-bind="formItemLayout">
        <a-button type="dashed" @click="add">
          <a-icon type="plus" />Tambah Kriteria
        </a-button>
      </a-form-item>

      <a-form-item
        v-for="(k, index) in form.getFieldValue('keys')"
        v-bind="formItemLayout"
        :required="false"
        :key="k"
        :selectedColumn="selectedColumn[k]"
      >
        <a-select
          style="width: 30%;margin-right: 8px"
          @change="handleChange($event,k)"
          v-model="selectedColumnType[k]"
          labelInValue
        >
          <a-select-option v-for="column in columns" :key="column.dataIndex">{{column.title}}</a-select-option>
        </a-select>
        <a-input
          v-if="selectedColumn[k].fieldType === 'textbox'"
          v-decorator="[
        'filterValue.'+selectedColumn[k].columnType,
        {
          rules: [{
            required: true,
            whitespace: true,
            message: 'Silahkan isi kriteria pencarian',
          }],
          initialValue : formValue[selectedColumn[k].columnType]
        }
      ]"
          style="width: 30%; margin-right: 8px"
        />
        <a-select
          v-else-if="selectedColumn[k].fieldType === 'CityCombo'"
          showSearch
          placeholder="Select a City"
          style="width: 30%;margin-right: 8px"
          :filterOption="filterOption"
          v-decorator="[
        'filterValue.'+selectedColumn[k].columnType,
          {
              rules: [{
                required: true,
                message: 'Silahkan isi kota',
              }],
          initialValue : formValue[selectedColumn[k].columnType]
          }
        ]"
        >
          <a-select-option v-for="city in cities" :key="city.name">{{city.name}}</a-select-option>
        </a-select>
        <a-select
          v-else-if="selectedColumn[k].fieldType === 'StatusCombo'"
          showSearch
          placeholder="Select a Status"
          optionFilterProp="children"
          style="width: 30%;margin-right: 8px"
          :filterOption="filterOption"
          v-decorator="[
        'filterValue.'+selectedColumn[k].columnType,
          {
              rules: [{
                required: true,
                message: 'Silahkan isi status',
              }],
          initialValue : formValue[selectedColumn[k].columnType]
          }
        ]"
        >
          <a-select-option v-for="status in statuses" :key="status.code">{{status.name}}</a-select-option>
        </a-select>
        <a-range-picker
          v-else-if="selectedColumn[k].fieldType === 'datebox'"
          style="margin-right: 8px"
          format="DD/MM/YYYY"
          v-decorator="[
        'filterValue.'+selectedColumn[k].columnType,
          {
              rules: [{
                type: 'array',
                required: true,
                message: 'Silahkan isi tanggal',
              }],
          initialValue : formValue[selectedColumn[k].columnType]
          }
        ]"
        />
        <a-input-number v-else style="width: 30%; margin-right: 8px" />

        <a-icon
          v-if="form.getFieldValue('keys').length > 1"
          class="dynamic-delete-button"
          type="minus-circle-o"
          :disabled="form.getFieldValue('keys').length === 1"
          @click="() => remove(k)"
        />
      </a-form-item>

      <a-form-item v-bind="formItemLayout">
        <a-button class="buttonFilter" type="primary" htmlType="submit">Cari</a-button>
        <a-button class="buttonFilter" type="primary" @click="exportToExcel">Export</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ComboService from "@/services/ComboService";

let id = 0;

const masterColumns = [
  {
    title: "No STTB",
    dataIndex: "awbNumber",
    sorter: true,
    fieldType: "textbox"
  },
  {
    title: "Tanggal",
    sorter: true,
    dataIndex: "pickupDate",
    fieldType: "datebox"
  },
  {
    title: "Pengirim",
    sorter: true,
    dataIndex: "senderName",
    fieldType: "textbox"
  },
  {
    title: "Kota Asal",
    sorter: true,
    dataIndex: "senderCity",
    fieldType: "CityCombo"
  },
  {
    title: "Tujuan",
    sorter: true,
    dataIndex: "destName",
    fieldType: "textbox"
  },
  {
    title: "Kota Tujuan",
    sorter: true,
    dataIndex: "destCity",
    fieldType: "CityCombo"
  },
  {
    title: "Coli",
    sorter: true,
    dataIndex: "coli",
    fieldType: "numberbox"
  },
  {
    title: "Status",
    sorter: false,
    dataIndex: "last_status",
    fieldType: "StatusCombo"
  }
];

const columnType = {
  awbNumber: "textbox",
  pickupDate: "datebox",
  senderName: "textbox",
  senderCity: "CityCombo",
  destName: "textbox",
  destCity: "CityCombo",
  coli: "numberbox",
  last_status: "StatusCombo"
};

export default {
  mounted() {
    // eslint-disable-next-line no-console
    this.fetchCity();
    const keys = this.fieldValue.keys;
    this.selectedColumn = this.fieldValue.selectedColumn;
    this.selectedColumnType = this.fieldValue.selectedColumnType;

    this.form.setFieldsValue({
      keys: keys,
      selectedColumn: this.selectedColumn
    });

    if (this.filters != "") {
      this.$emit("closePanel");
    }
  },
  components: {},
  beforeCreate() {
    // eslint-disable-next-line no-console

    this.form = this.$form.createForm(this);
    this.form.getFieldDecorator("keys", { initialValue: [] });
    this.form.getFieldDecorator("selectedColumn", { initialValue: {} });
  },
  data() {
    return {
      cities: [],
      statuses: [
        {
          code: "NOTOK",
          name: "On Process"
        },
        {
          code: "OK",
          name: "Delivered"
        }
      ],
      columns: masterColumns,
      masterColumns: masterColumns,
      selectedColumn: this.form.getFieldValue("selectedColumn"),
      searchColumn: [],
      selectedColumnType: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      searchError: null,
      filterCriteria: []
    };
  },
  methods: {
    ...mapActions("shipment", ["filtered", "fieldValues", "formValues"]),
    setFilters(filterCriteria) {
      this.filtered(filterCriteria);
    },
    remove(k) {
      const { form } = this;
      const keys = form.getFieldValue("keys");
      var selectedColumn = form.getFieldValue("selectedColumn");

      if (keys.length === 1) {
        return;
      }

      delete selectedColumn[k];
      delete this.searchColumn[k];
      delete this.selectedColumnType[k];

      // can use data-binding to set
      form.setFieldsValue({
        keys: keys.filter(key => key !== k),
        selectedColumn: selectedColumn
      });

      this.fieldValues({
        keys: keys.filter(key => key !== k),
        selectedColumn: selectedColumn,
        selectedColumnType: this.selectedColumnType
      });

      this.columns = this.masterColumns.filter(
        x => !this.searchColumn.includes(x.dataIndex)
      );
    },

    add() {
      const { form } = this;

      const keys = form.getFieldValue("keys");
      const selectedColumn = form.getFieldValue("selectedColumn");

      // eslint-disable-next-line no-console
      const nextKeys = keys.concat(++id);
      var col = {};
      col[id] = "";

      const nextSelected = Object.assign(selectedColumn, col);

      form.setFieldsValue({
        keys: nextKeys,
        selectedColumn: nextSelected
      });

      this.fieldValues({
        keys: nextKeys,
        selectedColumn: nextSelected,
        selectedColumnType: this.selectedColumnType
      });

      this.searchError = null;
    },

    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {
          const formdata = values.filterValue;
          var formdataVal = {};
          if (typeof formdata !== "undefined") {
            this.filterCriteria = [];
            for (var k in formdata) {
              if (formdata.hasOwnProperty(k) && k != "") {
                // eslint-disable-next-line no-console
                formdataVal[k] = formdata[k];
                switch (k) {
                  case "pickupDate":
                    this.filterCriteria.push({
                      field: k,
                      operator: "range",
                      value: {
                        start: formdata[k][0].format("YYYY-MM-DD"),
                        end: formdata[k][1].format("YYYY-MM-DD")
                      }
                    });
                    break;
                  case "awbNumber":
                  case "senderName":
                  case "destName":
                    this.filterCriteria.push({
                      field: k,
                      operator: "contains",
                      value: formdata[k]
                    });
                    break;
                  case "last_status":
                    // eslint-disable-next-line no-console
                    console.log(formdata[k]);
                    if (formdata[k] == "NOTOK") {
                      this.filterCriteria.push({
                        field: k,
                        operator: "notequals",
                        value: "OK"
                      });
                    } else {
                      this.filterCriteria.push({
                        field: k,
                        operator: "contains",
                        value: formdata[k]
                      });
                    }

                    break;
                  default:
                    this.filterCriteria.push({
                      field: k,
                      operator: "equals",
                      value: formdata[k]
                    });
                    break;
                }
              }
            }

            // eslint-disable-next-line no-console
            this.setFilters(this.filterCriteria);
            this.formValues(formdataVal);
            this.$emit("closePanel");
          } else {
            this.searchError =
              "Tidak ditemukan kriteria pencarian, kriteria tidak boleh kosong";
          }
        }
      });
    },
    handleChange(value, key) {
      const { form } = this;

      // this.selectedColumn[key] = columnType[value];
      this.selectedColumn[key] = {
        fieldType: columnType[value.key],
        columnType: value.key
      };

      this.searchColumn[key] = value.key;

      this.selectedColumnType[key] = {
        key: value.key,
        label: value.label
      };

      form.setFieldsValue({
        selectedColumn: this.selectedColumn
      });

      this.fieldValues({
        keys: this.fieldValue.keys,
        selectedColumn: this.selectedColumn,
        selectedColumnType: this.selectedColumnType
      });

      this.columns = this.masterColumns.filter(
        x => !this.searchColumn.includes(x.dataIndex)
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    fetchCity(params = {}) {
      const vthis = this;
      const resArray = [];
      ComboService.getCityData(
        params,
        function(data) {
          const results = data.data;
          const map = new Map();
          for (const item of results.resource) {
            if (!map.has(item.name)) {
              map.set(item.name, true);
              resArray.push(item);
            }
          }

          vthis.cities = resArray;
        },
        function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        }
      );
    },
    exportToExcel() {
      // eslint-disable-next-line no-console
      this.form.validateFields((err, values) => {
        if (!err) {
          const formdata = values.filterValue;
          const authUser = JSON.parse(window.localStorage.getItem("userljrs"));

          var query = "&customerId=" + authUser.customerId;
          if (typeof formdata !== "undefined") {
            for (var k in formdata) {
              if (formdata.hasOwnProperty(k) && k != "") {
                // eslint-disable-next-line no-console
                switch (k) {
                  case "pickupDate":
                    query +=
                      "&startDate=" + formdata[k][0].format("YYYY-MM-DD");
                    query += "&endDate=" + formdata[k][1].format("YYYY-MM-DD");
                    break;
                  case "awbNumber":
                  case "senderName":
                  case "destName":
                  case "last_status":
                    query += "&" + k + "=" + formdata[k];
                    break;
                  default:
                    query += "&" + k + "=" + formdata[k];
                    break;
                }
              }
            }

            var urlz =
              "http://lestarijayaraya.co.id:10090/api/v2/shipmentreportljrs?" +
              "api_key=f028d303982115f243e468c55dafdb6eda6bd6e0ac754f814fc35173f049cc2b" +
              query;

            window.open(urlz, "_blank");
          } else {
            this.searchError =
              "Tidak ditemukan kriteria pencarian, kriteria tidak boleh kosong";
          }
        }
      });
    }
  },
  computed: {
    ...mapGetters("shipment", ["filters", "fieldValue", "formValue"])
  }
};
</script>
<style>
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.buttonFilter {
  margin-right: 10px;
}
</style>